<script setup>
defineProps({
    title: {
        type: String,
        required: true,
    },
    subtitle: {
        type: String,
        default: "",
    },
    image: {
        type: String,
        default: "",
    },
    visibility: {
        type: String,
        default: "Public",
    },
});
</script>

<template>
    <article
        class="flex items-stretch justify-between gap-3 rounded-[4px] bg-white p-4 shadow-[0px_8px_25px_0px_rgba(0,0,0,0.08)]"
    >
        <div class="flex min-w-0 flex-col">
            <h3
                class="font-brand text-[15px] font-semibold leading-tight text-brand-navy"
            >
                {{ title }}
            </h3>
            <p
                v-if="subtitle"
                class="mt-1 font-brand text-[11px] leading-tight text-[#565a77]"
            >
                {{ subtitle }}
            </p>
            <div class="mt-auto flex items-center">
                <span
                    class="inline-flex w-fit items-center gap-1.5 rounded-[2px] border border-[#e9e8e0] px-2 py-1 font-brand text-[10px] font-medium text-[#102a3d]"
                    :class="visibility === 'Private' ? 'bg-[#f0ece9]' : ''"
                >
                    <img
                        loading="lazy"
                        :src="
                            visibility === 'Private'
                                ? asset('images/brand/icon-lock.svg')
                                : asset('images/brand/icon-globe.svg')
                        "
                        alt=""
                        class="size-[10px]"
                    />
                    {{ visibility }}
                </span>

                <div
                    class="ml-auto flex items-center gap-4 pr-1 text-[#102a3d]/40"
                    aria-hidden="true"
                >
                    <svg
                        viewBox="0 0 11 12"
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="h-[15px] w-[14px]"
                    >
                        <path
                            d="M7.375 2.33333L5.5 0.5L3.625 2.33333M5.5 0.5V7.85615M2.37514 4.77778C1.79272 4.77778 1.50151 4.77778 1.27179 4.87079C0.965507 4.99484 0.722019 5.23293 0.595151 5.53244C0.5 5.75702 0.5 6.04162 0.5 6.61111V9.54444C0.5 10.229 0.5 10.571 0.636244 10.8324C0.756082 11.0624 0.94717 11.2498 1.18238 11.3669C1.4495 11.5 1.79937 11.5 2.49807 11.5H8.50225C9.20094 11.5 9.55031 11.5 9.81744 11.3669C10.0526 11.2498 10.2441 11.0624 10.3639 10.8324C10.5 10.5712 10.5 10.2295 10.5 9.54634V6.61111C10.5 6.04162 10.4999 5.75702 10.4048 5.53244C10.2779 5.23293 10.0346 4.99484 9.72838 4.87079C9.49863 4.77778 9.20744 4.77778 8.625 4.77778"
                        />
                    </svg>
                    <svg
                        viewBox="0 0 11 12"
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="h-[15px] w-[14px]"
                    >
                        <path
                            d="M9.25 2.33344V8.56677C9.25 9.59356 9.25 10.1069 9.04563 10.4991C8.86588 10.8441 8.57906 11.1245 8.22625 11.3003C7.82512 11.5001 7.30012 11.5001 6.25 11.5001H4.75C3.6999 11.5001 3.17485 11.5001 2.77377 11.3003C2.42096 11.1245 2.13413 10.8441 1.95436 10.4991C1.75 10.1069 1.75 9.59356 1.75 8.56677V2.33344M0.5 2.33344H10.5M8 2.33344L7.83087 1.83726C7.66694 1.35642 7.58494 1.11601 7.43294 0.938259C7.29869 0.781295 7.12631 0.6598 6.93156 0.584914C6.711 0.500104 6.45187 0.500104 5.9335 0.500104H5.0665C4.54813 0.500104 4.289 0.500104 4.06844 0.584914C3.8737 0.6598 3.7013 0.781295 3.56706 0.938259C3.41503 1.11601 3.33308 1.35642 3.16915 1.83726L3 2.33344"
                        />
                    </svg>
                </div>
            </div>
        </div>

        <div
            class="size-[102px] shrink-0 overflow-hidden rounded-[2px] bg-brand-tan/40 lg:size-[84px] xl:size-[102px]"
        >
            <img
                loading="lazy"
                v-if="image"
                :src="image"
                :alt="title"
                class="size-full object-cover"
            />
        </div>
    </article>
</template>
